import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useEffect } from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { ExpandLess, ExpandMore, Collapse, List, ListItem, ListItemText, Divider, Drawer, Skeleton } from "../..";
var drawerWidth = "240px";
var useStyles = makeStyles(function (theme) {
  return {
    drawer: {
      width: drawerWidth,
      flexShrink: 0
    },
    drawerPaper: {
      width: drawerWidth,
      zIndex: 900
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3)
    },
    toolbar: theme.mixins.toolbar,
    nested: {
      paddingLeft: theme.spacing(4),
      display: "inline-block",
      width: "100%",
      textDecoration: "none"
    },
    "nested:hover": {
      textDecoration: "none"
    },
    link: {
      textDecoration: "none"
    },
    "link:hover": {
      textDecoration: "none"
    }
  };
});

var SideDrawer = function SideDrawer(_ref) {
  var openMenu = _ref.openMenu,
      toggleDrawer = _ref.toggleDrawer,
      variant = _ref.variant,
      props = _objectWithoutProperties(_ref, ["openMenu", "toggleDrawer", "variant"]);

  var classes = useStyles();

  var _React$useState = React.useState([]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      itemsCollapse = _React$useState2[0],
      setItemsCollapse = _React$useState2[1];

  var handleClick = function handleClick(id) {
    // console.log(id);
    var auxItems = _toConsumableArray(itemsCollapse); // console.log("items", auxItems);


    auxItems = auxItems.map(function (item) {
      if (item.id === id) {
        // console.log("item", item);
        var value = item.open ? false : true;
        var auxItem = {
          id: id,
          open: value
        }; // console.log("item final", auxItem);

        return auxItem;
      } else {
        return item;
      }
    });
    setItemsCollapse(auxItems);
  };

  useEffect(function () {
    if (itemsCollapse.length === 0) {
      if (props.data.length > 0) {
        var initialItemsCollapse = [];
        props.data.forEach(function (item) {
          if (item.secondary) {
            initialItemsCollapse.push({
              open: false,
              id: item.primary.name
            });
          }
        });
        setItemsCollapse(initialItemsCollapse);
      } else {
        setItemsCollapse([]);
      }
    }
  }, [props.data]);
  var pathname = props.location.pathname;
  return /*#__PURE__*/React.createElement(Drawer, {
    anchor: "left",
    open: openMenu,
    onClose: toggleDrawer,
    key: 33233,
    className: classes.drawer,
    variant: variant,
    classes: {
      paper: classes.drawerPaper
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.toolbar
  }), /*#__PURE__*/React.createElement(List, {
    key: 0
  }, props.data.length ? props.data.map(function (item, index) {
    if (item.secondary) {
      return [/*#__PURE__*/React.createElement(ListItem, {
        component: Link,
        to: item.primary.url,
        className: classes.link,
        button: true,
        key: item.primary.name,
        selected: item.primary.url === pathname,
        onClick: function onClick(e) {
          handleClick(item.primary.name);
        }
      }, /*#__PURE__*/React.createElement(ListItemText, {
        primary: item.primary.name
      }), (itemsCollapse.find(function (_item) {
        return _item.id === item.primary.name;
      }) ? itemsCollapse.find(function (_item) {
        return _item.id === item.primary.name;
      }).open : false) ? /*#__PURE__*/React.createElement(ExpandLess, null) : /*#__PURE__*/React.createElement(ExpandMore, null)), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Collapse, {
        "in": itemsCollapse.find(function (_item) {
          return _item.id === item.primary.name;
        }) ? itemsCollapse.find(function (_item) {
          return _item.id === item.primary.name;
        }).open : false,
        timeout: "auto",
        unmountOnExit: true
      }, item.secondary && item.secondary.map(function (element, index) {
        return /*#__PURE__*/React.createElement(List, {
          key: index,
          component: "div",
          disablePadding: true
        }, element.target ? /*#__PURE__*/React.createElement(ListItem, {
          component: "a",
          href: element.url,
          target: element.target,
          className: classes.nested,
          button: true,
          key: element.name,
          selected: element.url === pathname
        }, /*#__PURE__*/React.createElement(ListItemText, {
          primary: element.name
        })) : /*#__PURE__*/React.createElement(ListItem, {
          component: Link,
          to: element.url,
          className: classes.nested,
          button: true,
          key: element.name,
          selected: element.url === pathname
        }, /*#__PURE__*/React.createElement(ListItemText, {
          primary: element.name
        })), /*#__PURE__*/React.createElement(Divider, null));
      }))];
    } else if (item.primary.target) {
      // console.log(item);
      return [/*#__PURE__*/React.createElement(ListItem, {
        component: "a",
        href: item.primary.url,
        target: item.primary.target,
        className: classes.link,
        button: true,
        key: item.name,
        selected: item.primary.url === pathname
      }, /*#__PURE__*/React.createElement(ListItemText, {
        primary: item.primary.name
      })), /*#__PURE__*/React.createElement(Divider, null)];
    } else if (item.primary.url.charAt(0) === "/") {
      return [/*#__PURE__*/React.createElement(ListItem, {
        component: Link,
        to: item.primary.url,
        className: classes.link,
        button: true,
        key: item.name,
        selected: item.primary.url === pathname
      }, /*#__PURE__*/React.createElement(ListItemText, {
        primary: item.primary.name
      })), /*#__PURE__*/React.createElement(Divider, null)];
    } else return false;
  }) : /*#__PURE__*/React.createElement(Skeleton, {
    count: 5,
    height: 40
  })));
};

export default withRouter(SideDrawer);